import React, { Component, useEffect, useState } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import PrivateRoute from './Utils/PrivateRoute'
import { AuthProvider, useAuth } from './Context/Auth'
import { getCurrentUserRole } from './Context/firebase'

// import Home from './Pages/Home'
import LoginPage from './Pages/Login'
import SignUp from './Pages/Signup'
import ResetPassword from './Pages/ResetPassword'
import Events from './Pages/MyEvents'
import ActivitiesLibrary from './Pages/ActivitiesLibrary'
import FavoritesLibrary from './Pages/FavoritesLibrary'
import Activity from './Pages/Activity'
import Settings from './Pages/Settings'
import PageLayout from './Layouts/PageLayout'
import CreateEvent from './Pages/CreateEvent'
import Event from './Pages/EventPage'
import ParticipantView from './Pages/ParticipantViewEventPage'
import NotFound404 from './Pages/NotFound404'
import EventDecription from './Pages/EventDescription'
import EditEvent from './Pages/EditEvent'
import AdminPanel from './Pages/AdminPanel'
import CommunityPage from './Pages/Community'
import LearningCenter from './Pages/LearningCenter'

const AuthentificatedStack = () => {
  const [userRole, setUserRole] = useState()
  useEffect(() => {
    getCurrentUserRole().then(setUserRole)
  }, [])

  return (
    <Switch>
      <Route exact path='/' component={Events} />
      <Route exact path='/events' component={Events} />
      <Route exact path='/events/:eventId' component={Event} />
      <Route exact path='/events/:eventId/event' component={EventDecription} />
      <Route exact path='/events/:eventId/edit' component={EditEvent} />
      <Route exact path='/create' component={CreateEvent} />
      <Route exact path='/settings' component={Settings} />
      <Route path='/community' component={CommunityPage} />
      <Route path='/learning-center' component={LearningCenter} />
      <Route exact path='/activities' component={ActivitiesLibrary} />
      <Route exact path='/activities/:cardId' component={Activity} />
      <Route exact path='/favorites' component={FavoritesLibrary} />
      <Route exact path='/favorites/:cardId' component={Activity} />
      {userRole === 'admin' && <Route exact path='/admin' component={AdminPanel} />}
      <Route component={NotFound404} />
    </Switch>
  )
}

const AuthRoute = ({ component: Component, ...rest }) => {
  const { currentUser } = useAuth()

  return (
    <Route
      {...rest}
      render={props => !currentUser ? <Component {...props} /> : <Redirect to='/events' />}
    />
  )
}

class App extends Component {
  render () {
    return (
      <Router>
        <Switch>
          <Route path='/event/:eventId' component={ParticipantView} />
          <AuthProvider>
            <PageLayout>
              <AuthRoute exact path='/login' component={LoginPage} />
              <AuthRoute exact path='/signup' component={SignUp} />
              <AuthRoute exact path='/resetpassword' component={ResetPassword} />
              <PrivateRoute path='/' component={AuthentificatedStack} />
            </PageLayout>
          </AuthProvider>
        </Switch>
      </Router>
    )
  }
}

export default App
